import { Construction } from "lucide-react";
import { useT } from "../../lib/i18n";
import { Button } from "../ui/button";

export default function EmptyState({ title, description, phase = "Phase 1+", testid }) {
  const t = useT();
  return (
    <div data-testid={testid || "empty-state"} className="flex flex-col items-center justify-center text-center py-24 px-6">
      <div className="size-14 rounded-full bg-accent grid place-items-center mb-4">
        <Construction className="size-6 text-muted-foreground" />
      </div>
      <h2 className="text-2xl font-semibold tracking-tight mb-2">{title}</h2>
      <p className="text-sm text-muted-foreground max-w-md mb-1">{description}</p>
      <p className="text-xs text-muted-foreground/80 mb-6">{t("common.available_phase", { phase })}</p>
      <Button asChild variant="outline" size="sm">
        <a href="/docs/ROADMAP.md" target="_blank" rel="noreferrer">{t("common.view_roadmap")}</a>
      </Button>
    </div>
  );
}
